import { myAxios } from './helper';
import { getToken } from "./user-service";

export const getAllContactRequests = async () => {
  try {
      const token = getToken();
      const response = await myAxios.get("/api/contact/all", {
          headers: {
              Authorization: `Bearer ${token}`,
          },
      });
      return response.data.data;
  } catch (error) {
      console.error("Error fetching contact requests:", error);
      throw error;
  }
};

export const getRequestCountByStatus = async (status) => {
  try {
    const token = getToken();
    const response = await myAxios.get(`/api/contact/count/${status}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.data;
  } catch (error) {
    console.error(`Error fetching ${status} count:`, error);
    return 0;
  }
};

export const submitSupportRequest = async (email, message, files = []) => {
  const formData = new FormData();
  formData.append('email', email);
  formData.append('message', message);

  files.forEach((file) => 
    formData.append('files', file)
  );

  const response = await myAxios.post('/api/support/submit', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data.data;
};

export const updateRequestStatus = async (id, status, customMessage = "") => {
  try {
    const token = getToken();
    const params = new URLSearchParams();
    params.append("status", status);
    if (customMessage) {
      params.append("customMessage", customMessage);
    }
    
    const response = await myAxios.put(
      `/api/contact/update-status/${id}?${params.toString()}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.data;
  } catch (error) {
    console.error("Error updating status:", error);
    throw error;
  }
};

export const getRegisteredContactRequests = async () => {
  try {
    const token = getToken();
    const response = await myAxios.get("/api/contact/registered", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.data;
  } catch (error) {
    console.error("Error fetching registered contact requests:", error);
    throw error;
  }
};

export const getUnregisteredContactRequests = async () => {
  try {
    const token = getToken();
    const response = await myAxios.get("/api/contact/unregistered", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.data;
  } catch (error) {
    console.error("Error fetching unregistered contact requests:", error);
    throw error;
  }
};
export const submitRegisteredRequest = async (payload) => {
  const token = getToken();
  const response = await myAxios.post("/api/contact/contact", payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.data;
};
export const submitRegisteredRequestWithFile = async (formData) => {
  const token = getToken();
  const response = await myAxios.post("/api/contact/contact", formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data.data;
};
export const getTicketMessages = async (ticketId) => {
  try {
    const token = getToken();
    const response = await myAxios.get(`/api/contact/messages/${ticketId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.data;
  } catch (error) {
    console.error("Error fetching ticket messages:", error);
    throw error;
  }
};

export const sendTicketMessage = async (ticketId, messagePayload) => {
  try {
    const token = getToken();
    const response = await myAxios.post(`/api/contact/messages/${ticketId}`, messagePayload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.data;
  } catch (error) {
    console.error("Error sending ticket message:", error);
    throw error;
  }
};
export const getUserTicketHistory = async () => {
  try {
    const token = getToken();
    const response = await myAxios.get("/api/contact/ticket-history", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.data;
  } catch (error) {
    console.error("Error fetching user ticket history:", error);
    throw error;
  }
};
export const confirmTicketResolution = async (ticketId, response) => {
  try {
    const token = getToken();
    const result = await myAxios.put(
      `/api/contact/confirm-resolved/${ticketId}?response=${response}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return result.data.data;
  } catch (error) {
    console.error("Error confirming resolution:", error);
    throw error;
  }
};
export const getFile = async (contactRequestId, fileName) => {
  try {
    const token = getToken();
    const response = await myAxios.get(`/api/contact/file/contact/${contactRequestId}?fileName=${encodeURIComponent(fileName)}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: 'blob',
    });
    return response;
  } catch (error) {
    console.error(`Error fetching file for contact request ID ${contactRequestId}:`, error);
    throw error;
  }
};
export const sendAcknowledgment = async (requestId, response) => {
  try {
    const token = getToken();
    const res = await myAxios.get(`/api/contact/acknowledge`, {
      params: { requestId, response },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data.data;
  } catch (error) {
    console.error("Error sending acknowledgment:", error);
    throw error;
  }
};